<!-- <div class="full-page container-fluid w-100 d-flex">
  <div class="text-center maintenance-container">
    <img src="assets/images/logo-black.svg" class="logo mb-5" />
    <div class="maintenance-description mt-5">
      <div class="text-primary icon material-icons mb-3">engineering</div>
      <h4 class="text-primary mb-3">{{ 'maintenancepage.title' | translate }}</h4>
      <p
        class="text-black font-size-14 px-4"
        [translate]="'maintenancepage.description'"
        [translateParams]="{ fgbdefault: 'Sorry, we’re down for scheduled maintenance right now. Please check back later' }"
      ></p>
    </div>
  </div>
</div> -->

<div class="full-page panel w-100">
  <div class="overflow-hidden p-0">
    <div class="user-login-panel d-flex align-items-center justify-content-center">
      <div class="container">
        <div class="login-banner mx-auto">
          <img src="assets/images/logo-black.svg" class="logo" />
        </div>
        <div class="col-12 user-login-panel-content mx-auto rounded-4 bg-secondary">
          <div class="icon material-symbols-outlined maintenance-icon mb-4 text-tertiary">engineering</div>
          <h5 class="heading-text text-tertiary">{{ 'maintenance.page.text' | translate }}</h5>
          <p
            class="font-size-14 panel-text mlb-text mb-0 text-white"
            [innerHTML]="'maintenance.page.description' | translate | markdownTranslate"
          ></p>
        </div>
      </div>
    </div>
  </div>
</div>
